import * as React from 'react';
export const hubspotSvg = React.forwardRef(function hubspotSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#EB683C',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M22.133 12.24V9.624a2.015 2.015 0 0 0 1.163-1.817v-.062a2.019 2.019 0 0 0-2.013-2.014h-.062a2.02 2.02 0 0 0-2.014 2.014v.062a2.015 2.015 0 0 0 1.162 1.816v2.618a5.713 5.713 0 0 0-2.716 1.195l-7.19-5.593c.052-.184.08-.375.082-.566A2.272 2.272 0 1 0 8.27 9.545a2.247 2.247 0 0 0 1.123-.306l7.07 5.503a5.727 5.727 0 0 0 .088 6.46l-2.152 2.15a1.849 1.849 0 0 0-.533-.087 1.868 1.868 0 1 0 1.866 1.867 1.838 1.838 0 0 0-.087-.533l2.129-2.128a5.74 5.74 0 0 0 8.498-7.347 5.74 5.74 0 0 0-4.14-2.883Zm-.88 8.614a2.945 2.945 0 1 1-.114-5.89 2.945 2.945 0 0 1 .114 5.89Z',
      fill: '#fff',
    }),
  );
});
hubspotSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var hubspot = {
  category: 'brand',
  colorable: false,
  name: 'hubspot',
  svg: hubspotSvg,
};
